/* FeesBees wishlist: guests save for the session, logged-in customers save on this device */
(function () {
  var cfg = window.FBWishlistConfig || {};
  var cid = cfg.customerId ? String(cfg.customerId) : '';
  var GUEST = 'fb-wishlist-guest';
  var KEY = cid ? 'fb-wishlist-c' + cid : GUEST;
  var tab = 'wish';
  var root, body, countEl, lastFocus;

  var P = 'M9 15.25S1 10.6 1 5.4A4.15 4.15 0 0 1 9 3.6a4.15 4.15 0 0 1 8 1.8c0 5.2-8 9.85-8 9.85Z';
  var HEART_PURPLE = '<svg viewBox="0 0 18 16" aria-hidden="true"><path d="' + P + '" fill="#e0bd72" stroke="#e0bd72" stroke-width="1.3" stroke-linejoin="round"/></svg>';
  var CLOCK = '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><circle cx="10" cy="10" r="8.25" stroke="#e0bd72" stroke-width="1.4"/><path d="M10 5.5V10l3 2" stroke="#e0bd72" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ARROW = '<svg viewBox="0 0 18 10" fill="none" aria-hidden="true"><path d="M1 5h15M12 1l4 4-4 4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var X = '<svg viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M1 1l10 10M11 1 1 11" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

  function store() { try { return window.localStorage; } catch (e) { return null; } }
  // Guest saves live in localStorage (shared across tabs) but are wiped when the browser session ends,
  // tracked with a session cookie that has no expiry date.
  function hasSession() { return document.cookie.split('; ').indexOf('fb_wl_s=1') > -1; }
  if (!hasSession()) { try { window.localStorage.removeItem(GUEST); } catch (e) {} }
  try { document.cookie = 'fb_wl_s=1; path=/; SameSite=Lax'; } catch (e) {}
  function read(s, k) {
    try {
      var v = s && s.getItem(k);
      var d = v ? JSON.parse(v) : {};
      return { wish: Array.isArray(d.wish) ? d.wish : [], later: Array.isArray(d.later) ? d.later : [] };
    } catch (e) { return { wish: [], later: [] }; }
  }
  var data = read(store(), KEY);
  function write() { try { var s = store(); if (s) s.setItem(KEY, JSON.stringify(data)); } catch (e) {} }
  function find(id) {
    id = String(id);
    var all = data.wish.concat(data.later);
    for (var i = 0; i < all.length; i++) { if (String(all[i].id) === id) return all[i]; }
    return null;
  }
  function inWish(id) { id = String(id); return data.wish.some(function (p) { return String(p.id) === id; }); }
  function removeFrom(list, id) { id = String(id); data[list] = data[list].filter(function (p) { return String(p.id) !== id; }); }

  // Carry a guest's session saves over once they log in
  if (cid) {
    try {
      var g = read(window.localStorage, GUEST);
      if (g.wish.length || g.later.length) {
        ['wish', 'later'].forEach(function (l) { g[l].forEach(function (p) { if (!find(p.id)) data[l].push(p); }); });
        write();
        window.localStorage.removeItem(GUEST);
      }
    } catch (e) {}
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function parse(b) { try { return JSON.parse(b.getAttribute('data-product')); } catch (e) { return null; } }

  function notice() {
    if (cid) return '';
    return '<div class="fb-wl__notice">' + CLOCK + '<p>Saves stay through this session. <strong>Log in to keep them permanently.</strong></p></div>';
  }
  function actions() {
    if (cid) return '<button type="button" class="fb-wl__btn fb-wl__btn--secondary" data-fb-wl-close>Keep browsing</button>';
    return '<a class="fb-wl__btn fb-wl__btn--primary" href="' + esc(cfg.loginUrl) + '">Log in to save permanently ' + ARROW + '</a>' +
      '<button type="button" class="fb-wl__btn fb-wl__btn--secondary" data-fb-wl-close>Keep browsing first</button>' +
      '<p class="fb-wl__signup">No account? <a href="' + esc(cfg.registerUrl || cfg.loginUrl) + '">Sign up \u2014 it takes a minute</a></p>';
  }
  function empty() {
    if (tab === 'later') {
      return '<div class="fb-wl__empty"><span class="fb-wl__bubble">' + HEART_PURPLE + '</span>' +
        '<p class="fb-wl__lead">Nothing saved for later</p>' +
        '<p class="fb-wl__sub">Move items here from your wishlist to keep them aside.</p></div>' + notice() + '<hr class="fb-wl__rule">' + actions();
    }
    return '<div class="fb-wl__empty"><span class="fb-wl__bubble">' + HEART_PURPLE + '</span>' +
      '<p class="fb-wl__lead">Save things as you browse</p>' +
      '<p class="fb-wl__sub">Tap \u2661 on any product. It lands here so you don\u2019t lose it.</p></div>' + notice() + '<hr class="fb-wl__rule">' + actions();
  }
  function item(p) {
    var url = esc(p.url);
    return '<li class="fb-wl__item">' +
      '<a class="fb-wl__img" href="' + url + '">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '') + '</a>' +
      '<div><a class="fb-wl__name" href="' + url + '">' + esc(p.title) + '</a>' +
      '<span class="fb-wl__price">' + esc(p.price) + '</span>' +
      '<div class="fb-wl__acts"><a class="fb-wl__link" href="' + url + '">View product</a>' +
      '<button type="button" class="fb-wl__move" data-fb-wl-move="' + esc(p.id) + '">' + (tab === 'wish' ? 'Save for later' : 'Move to wishlist') + '</button></div></div>' +
      '<button type="button" class="fb-wl__remove" data-fb-wl-remove="' + esc(p.id) + '" aria-label="Remove ' + esc(p.title) + '">' + X + '</button>' +
      '</li>';
  }
  function render() {
    if (!body) return;
    var list = data[tab];
    var html = list.length ? '<ul class="fb-wl__list">' + list.map(item).join('') + '</ul>' + (cid ? '' : notice() + '<hr class="fb-wl__rule">' + actions()) : empty();
    body.innerHTML = html;
    root.querySelectorAll('[data-fb-wl-tab]').forEach(function (b) {
      var on = b.getAttribute('data-fb-wl-tab') === tab;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    syncCount();
  }
  function syncButtons() {
    document.querySelectorAll('[data-fb-wl-toggle]').forEach(function (b) {
      var p = parse(b);
      if (!p) return;
      var on = inWish(p.id);
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }
  function syncCount() {
    var n = data.wish.length;
    if (countEl) countEl.textContent = n;
    document.querySelectorAll('[data-fb-wl-header-count]').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : n;
      el.hidden = n === 0;
    });
    document.querySelectorAll('[data-fb-wl-open]').forEach(function (b) {
      b.setAttribute('aria-label', n ? 'Wishlist (' + n + ' item' + (n === 1 ? '' : 's') + ')' : 'Wishlist');
    });
  }
  function sync() { syncButtons(); syncCount(); if (root && !root.hidden) render(); }
  function toggle(p) {
    if (inWish(p.id)) { removeFrom('wish', p.id); }
    else { removeFrom('later', p.id); data.wish.unshift(p); }
    write(); sync();
  }
  function open() {
    if (!root) return;
    lastFocus = document.activeElement;
    tab = 'wish';
    root.hidden = false;
    render();
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
    document.documentElement.classList.add('fb-wl-lock');
    var panel = root.querySelector('.fb-wl__panel');
    if (panel) panel.focus();
  }
  function close() {
    if (!root || root.hidden) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('fb-wl-lock');
    setTimeout(function () { root.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-fb-wl-toggle]');
    if (t) { e.preventDefault(); e.stopPropagation(); var p = parse(t); if (p) toggle(p); return; }
    if (e.target.closest('[data-fb-wl-open]')) { e.preventDefault(); e.stopPropagation(); open(); return; }
    if (!root || !root.contains(e.target)) return;
    if (e.target.closest('[data-fb-wl-close]')) { e.preventDefault(); close(); return; }
    var tb = e.target.closest('[data-fb-wl-tab]');
    if (tb) { tab = tb.getAttribute('data-fb-wl-tab'); render(); return; }
    var rm = e.target.closest('[data-fb-wl-remove]');
    if (rm) { removeFrom(tab, rm.getAttribute('data-fb-wl-remove')); write(); sync(); return; }
    var mv = e.target.closest('[data-fb-wl-move]');
    if (mv) {
      var id = mv.getAttribute('data-fb-wl-move');
      var prod = find(id);
      var to = tab === 'wish' ? 'later' : 'wish';
      removeFrom(tab, id);
      if (prod) data[to].unshift(prod);
      write(); sync();
    }
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  window.addEventListener('storage', function (e) { if (e.key === KEY) { data = read(store(), KEY); sync(); } });

  function init() {
    root = document.getElementById('fb-wishlist');
    if (root) { body = root.querySelector('[data-fb-wl-body]'); countEl = root.querySelector('[data-fb-wl-count]'); }
    sync();
    var timer;
    new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(syncButtons, 100); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
